import React, { useState, useEffect } from 'react';
import { FaBars } from 'react-icons/fa';
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavRouterLink,
  NavBtn,
  NavBtnLink
} from './NavbarElements';
import { IconContext } from 'react-icons/lib';
import { animateScroll as scroll } from 'react-scroll';
import logo from '../../images/SoftSol_Logo_2025.png';

const Navbar = ({ toggle }) => {
  const [scrollNav, setScrollNav] = useState(false);

  const changeNav = () => {
    setScrollNav(window.scrollY >= 80);
  };

  useEffect(() => {
    window.addEventListener('scroll', changeNav);
  }, []);

  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <IconContext.Provider value={{ color: '#fff' }}>
      <Nav scrollNav={scrollNav}>
        <NavbarContainer>
          <NavLogo to="/" onClick={toggleHome}>
            <img
              src={logo}
              alt="Software Solution Logo"
              style={{ height: '50px', marginRight: '10px' }}
            />
            Software Solution
          </NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
            {[
              { to: 'about', title: 'Über uns' },
              { to: 'discover', title: 'Lösungen' },
              { to: 'services', title: 'Leistungen' },
              { to: 'servicepackages', title: 'Servicepakete' },
              { to: 'contact', title: 'Kontakt' },
              { to: 'testimonials', title: 'Kundenstimmen' }
            ].map(({ to, title }) => (
              <NavItem key={to}>
                <NavLinks
                  to={to}
                  smooth={true}
                  duration={500}
                  spy={true}
                  exact="true"
                  offset={-80}
                >
                  {title}
                </NavLinks>
              </NavItem>
            ))}
            <NavItem>
              <NavRouterLink to="/fernwartung">Fernwartung</NavRouterLink>
            </NavItem>
          </NavMenu>

          {/* CTA Button Rechts */}
          <NavBtn>
            <NavBtnLink 
              to="contact"
              smooth={true}
              duration={500}
              spy={true}
              offset={-80}   // gleicht die sticky Navbar aus
            >
              Gratis IT-Check
            </NavBtnLink>
          </NavBtn>
        </NavbarContainer>
      </Nav>
    </IconContext.Provider>
  );
};

export default Navbar;
